<li><formstep-detail html-id="basisdaten" :options="options" :editable="true" :model="template"></formstep-detail></li>